/* PURRZ footer — safe to load once or twice: the whole file is a no-op on a
   second load, so it works whether or not the theme already bundles it. */
;(() => {
  if (window.__purrzFooterJsLoaded) return
  window.__purrzFooterJsLoaded = true

  class FooterSection extends HTMLElement {
    connectedCallback() {
      this.ids = {
        mobileNav: 'MobileNav',
        footerNavWrap: 'FooterMobileNavWrap',
        footerNav: 'FooterMobileNav'
      }

      this.init()
    }

    init() {
      // Change email icon to submit text
      const newsletterInput = document.querySelector('.footer__newsletter-input')
      if (newsletterInput) {
        newsletterInput.addEventListener('keyup', function () {
          newsletterInput.classList.add('footer__newsletter-input--active')
        })
      }

      this.mobileMediaQuery = window.matchMedia('(max-width: 768px)')
      // If on mobile, copy the mobile nav to the footer
      if (this.mobileMediaQuery.matches) {
        this.initDoubleMobileNav()
      }
      // Listen for changes to the media query
      this.mobileMediaQuery.addListener(this.handleMediaQueryChange.bind(this))
    }

    handleMediaQueryChange(mql) {
      if (mql.matches) {
        this.initDoubleMobileNav()
      }
    }

    initDoubleMobileNav() {
      if (this.hasDoubleMobileNav) {
        return
      }

      const menuPlaceholder = document.getElementById(this.ids.footerNavWrap)
      if (!menuPlaceholder) {
        return
      }

      const mobileNav = document.querySelector(`mobile-nav[container="${this.ids.mobileNav}"]`)
      const footerNav = document.getElementById(this.ids.footerNav)
      const clone = mobileNav.cloneNode(true)
      clone.setAttribute('container', this.ids.footerNav)
      clone.setAttribute('inHeader', 'false')

      // Append cloned nav to footer, initialize JS, then show it
      footerNav.appendChild(clone)

      menuPlaceholder.classList.remove('hide')
      this.hasDoubleMobileNav = true
    }
  }

  // Guarded: the theme may already load this file, and defining twice throws.
  if (!customElements.get('footer-section')) {
    customElements.define('footer-section', FooterSection)
  }

  /* ==========================================================================
     PURRZ footer behaviour
     Staggered entrance, back to top, and a dog animation that only downloads
     its player once the footer is actually near the viewport.
     Progressive enhancement: without JS everything is visible and usable.
     ========================================================================== */
  ;(() => {
    const ROOT = '[data-purrz-footer]'
    const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)')
    const LOTTIE_SRC = 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js'

    let lottieRequest = null

    function loadLottie() {
      if (lottieRequest) return lottieRequest
      if (window.customElements && window.customElements.get('lottie-player')) {
        lottieRequest = Promise.resolve()
        return lottieRequest
      }
      lottieRequest = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = LOTTIE_SRC
        script.async = true
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
      return lottieRequest
    }

    function initDog(root) {
      const holder = root.querySelector('[data-footer-lottie]')
      if (!holder || holder.dataset.ready === 'true') return
      if (REDUCED.matches) return

      const start = () => {
        if (holder.dataset.ready === 'true') return
        holder.dataset.ready = 'true'
        loadLottie()
          .then(() => {
            const player = document.createElement('lottie-player')
            player.setAttribute('src', holder.dataset.src || '')
            player.setAttribute('background', 'transparent')
            player.setAttribute('speed', '1')
            player.setAttribute('loop', '')
            player.setAttribute('autoplay', '')
            holder.appendChild(player)
            window.requestAnimationFrame(() => holder.classList.add('is-ready'))
          })
          .catch(() => {})
      }

      if (!('IntersectionObserver' in window)) {
        start()
        return
      }

      const watcher = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            watcher.disconnect()
            start()
          })
        },
        { rootMargin: '400px 0px' }
      )
      watcher.observe(holder)
    }

    function initReveals(root) {
      const targets = Array.from(root.querySelectorAll('[data-footer-reveal]'))
      if (!targets.length) return

      targets.forEach((node, index) => node.style.setProperty('--reveal-order', index % 8))

      if (REDUCED.matches || !('IntersectionObserver' in window)) {
        targets.forEach((node) => node.classList.add('is-visible'))
        return
      }

      root.classList.add('is-revealing')

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Reveal on entry, and also for anything already scrolled past — landing
            // deep in the page must never leave a column invisible.
            const passed = entry.boundingClientRect.bottom < 0
            if (!entry.isIntersecting && !passed) return
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          })
        },
        { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
      )

      targets.forEach((node) => observer.observe(node))
    }

    function initBackToTop(root) {
      const button = root.querySelector('[data-footer-top]')
      if (!button) return
      button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: REDUCED.matches ? 'auto' : 'smooth' })
      })
    }

    function initRoot(root) {
      if (!root || root.dataset.purrzFooterReady === 'true') return
      root.dataset.purrzFooterReady = 'true'
      initReveals(root)
      initBackToTop(root)
      initDog(root)
    }

    function initWithin(container) {
      if (!container) return
      if (container.matches && container.matches(ROOT)) initRoot(container)
      if (container.querySelectorAll) container.querySelectorAll(ROOT).forEach(initRoot)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true })
    } else {
      initWithin(document)
    }

    document.addEventListener('shopify:section:load', (event) => initWithin(event.target))
  })()

})()
